import axiosInstance from '../helpers/axiosInstance';

export const getVerifiedProjectsApi = async (productId) => {
    const response = await axiosInstance.get(`staff/inward/verifiedProjectList/${productId}`);
    return response.data;
};

export const getInwardLogsApi = async (item) => {
    const response = await axiosInstance.get(`staff/inwardLogs?${item}`);
    return response.data;
};

export const getReceivedInwardsApi = async (item) => {
    const response = await axiosInstance.get(`staff/purchaseOrderProjects/yetToReceiveProducts?${item}`);
    return response.data;
};

export const addReturnInwardProductApi = async (request) => {
    const response = await axiosInstance.post('staff/products/inwardReturn', request.formData);
    return response.data;
};

export const getInwardCsvApi = async (item) => {
    const response = await axiosInstance.get(`staff/inwardLogs/csv?${item}`, { responseType: 'text' });
    return response.data;
};

export const getYetToReceiveCsvApi = async (item) => {
    const response = await axiosInstance.get(`staff/purchaseOrderProjects/yetToReceiveProducts/csv1?${item}`, { responseType: 'text' });
    return response.data;
};


